import { Outlet } from "react-router-dom"
import darkLogo from "@/assets/images/firme-dark.png"
import whiteLogo from "@/assets/images/firme-white.png"
import { ThemePicker } from "@/components/theme-picker"
import { useTheme } from "@/components/use-theme"
import { VerificationNotice } from "@/components/verification-notice"

const RootLayout = () => {
  const { theme } = useTheme()

  return (
    <div className="flex h-screen flex-col items-stretch">
      <header className="border-b text-center">
        <div className="container flex flex-row items-center justify-between py-4">
          <img
            src={theme === "dark" ? whiteLogo : darkLogo}
            alt="Firme"
            width="120px"
          />

          <div>
            <ThemePicker />
          </div>
        </div>
      </header>

      <main className="container grow py-5">
        <VerificationNotice />
        <Outlet />
      </main>

      <footer className="py-6">
        <div id="footer-portal" className="fixed bottom-0 z-[10] w-full"></div>
      </footer>
    </div>
  )
}
export { RootLayout }
